import React from "react";

export default props => (
  <svg
    {...props}
    viewBox="0 0 15 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12.5C1.89083 4.26583 9.16667 2.7775 9.16667 2.7775V0L15 5.53083L9.16667 11.1108V8.33333C9.16667 8.33333 4.025 8.19083 0 12.5Z"
      fill={props.fill}
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Share/index.js